import * as type from './mutation-types'
export const state = {
    status: -9999,
    errmsg: '',
    exchangeData: {},
    exStatus: 'exStatusing'
}
export function getCookiesObj() { 
    return document.cookie.split(';').reduce((f, sv) => {
        let _sv = sv.trim().split('=').map(v => {
            return v.trim()
        })
        f[_sv[0]] = _sv[1]   
        return f  
    }, {})
}
export const mutations = {
    [type.ERROR_RECEIVE](state, res) {},

    [type.EXCHANGE_REQUEST](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = (res && res.code) || -9999
        state.exchangeData = {}
        state.exStatus = 'exStatusing'
    },
    [type.EXCHANGE_RECEIVE](state, res) {
        state.errmsg = (res && res.reason) || ''
        state.status = res.code
        state.exchangeData = (res && res.content) || {}
        state.exStatus = state.status > -9999 && 'exStatused'
    }
}